import { Component, OnDestroy } from '@angular/core';
import { GlobalService } from './core/services/global.service';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription } from 'rxjs';
import { REQUEST_URLS } from './core/services/request-urls';
import { map , tap, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnDestroy {
    public watcher: Subscription;
    public mobile: boolean=false;
   
    public policyLink: string='';
    public termsLink: string='';
    private lang: string = localStorage.getItem('language') || 'en-US';
    constructor(private globalService: GlobalService, private mediaObserver: MediaObserver) {
        this.globalService.changeLanguage(this.lang);
        this.watcher = this.mediaObserver.asObservable()
        .pipe(
          // print the original event (does not affect output)
          tap((change:any) => {
            
            let devicelist = change.map(c => c.mqAlias);
            
                if (devicelist[0] == 'sm') {
                    this.mobile = true;
                }
                if (devicelist[0] == 'xs') {
                    this.mobile = true;
                }
                this.globalService.mobile = this.mobile;
              }),
          // prevent duplicate events
          distinctUntilChanged((prev, curr) => prev[0].mqAlias === curr[0].mqAlias),
          // edit the event to show mediaQuery aliases only (optional)
          map((arr: MediaChange[]) => arr.map((change: MediaChange) => change.mqAlias)),
          // print the deduplicated event (does not affect output)
          tap(change => {})
        )
        .subscribe()
        // this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
        //     if (change.mqAlias == 'sm') {
        //         this.mobile = true;
        //       }
        //       if (change.mqAlias == 'xs') {
        //         this.mobile = true;
        //       }
        //       this.globalService.mobile = this.mobile;
        //   });
          this.policyLink = `${this.globalService.mainHost}${
                REQUEST_URLS.policy_conditions
            }/${this.lang}`;
            this.termsLink = `${this.globalService.mainHost}${
                REQUEST_URLS.terms_conditions
            }/${this.lang}`;
    }    
    
    ngAfterViewInit() {
        const cookieStorage = {
            getItem: (item) => {
                const cookies = document.cookie
                    .split(';')
                    .map(cookie => cookie.split('='))
                    .reduce((acc, [key, value]) => ({ ...acc, [key.trim()]: value }), {});
                return cookies[item];
            },
            setItem: (item, value) => {
                document.cookie = `${item}=${value};`
            }
        }
                
        const storageType = cookieStorage;
        const consentPropertyName = 'IsUseCookies';
        const shouldShowPopup = () => !storageType.getItem(consentPropertyName);
        const saveToStorage = () => storageType.setItem(consentPropertyName, true);

       
        const acceptFn = event => {
            saveToStorage();
            consentPopup.classList.add('hidden');
        }
        const consentPopup = document.getElementById('consent-popup');
        const acceptBtn = document.getElementById('accept');
        if(acceptBtn){
            acceptBtn.addEventListener('click', acceptFn);
        }
    
        if (shouldShowPopup()) {
            setTimeout(() => {
                consentPopup.classList.remove('hidden');
            }, 2000);
        }
    }

    ngOnDestroy() {
        this.watcher?.unsubscribe();
    }
}
